import request from '@/utils/request';

async function baseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/point/${path}`,
    method,
    data: method === 'get' || method === 'delete' ? null : payload,
    params: method === 'get' || method === 'delete' ? payload : null,
  });
}
async function FormBaseRequest(path, payload, method) {
  return request({
    url: `/deployment-service/${path}`,
    method,
    data: method === 'get' || method === 'delete' ? null : payload,
    params: method === 'get' || method === 'delete' ? payload : null,
  });
}

export function queryAll(payload) {
  return baseRequest('query_all', payload, 'get');
}

export function pointDelete(payload) {
  return baseRequest('delete', payload, 'delete');
}
export function pointQueryDetails(payload) {
  return baseRequest('query_detail', payload, 'get');
}
export function pointOperateLogs(payload) {
  return baseRequest('operate_logs', payload, 'get');
}
export function pointFirmwareUpgradeLogs(payload) {
  return baseRequest('firmware_upgrade_logs', payload, 'get');
}
export function pointTypes(payload) {
  return baseRequest('types', payload, 'get');
}
// 添加或更新设备信息
export function pointCreateDeviceInfo(payload) {
  return FormBaseRequest('deployment/post_device_info', payload, 'post');
}

export function pointDeviceInfo(payload) {
  return FormBaseRequest('deployment/device_info', payload, 'get');
}
